import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Toaster } from "sonner";
import Routes from "./Routes";
import { initWhatsAppSettings } from "./utils/whatsapp";
import { captureUtmFromUrl } from "./utils/utmAttribution";
import { StaticDataProvider } from "./contexts/StaticDataContext";
import { useVersionCheck } from "./hooks/useVersionCheck";

function VersionCheck() {
  const { updateAvailable, reloadInSeconds, reloadNow } = useVersionCheck();
  const { t } = useTranslation();
  if (!updateAvailable) return null;
  // Banner top full-width con countdown. Antes era chip flotante abajo:
  // en desktop pasaba desapercibido y el reload esperaba 3 min. Ahora es
  // imposible ignorarlo — barra arriba con acción explícita y countdown.
  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        zIndex: 100000,
        background: 'linear-gradient(90deg, #f97316 0%, #ea580c 100%)',
        color: '#fff',
        boxShadow: '0 4px 20px rgba(234,88,12,0.35)',
        padding: '10px 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
        fontSize: 14, fontWeight: 600,
        flexWrap: 'wrap',
      }}
    >
      <span style={{ fontSize: 18, lineHeight: 1, animation: 'pmSpin 2s linear infinite' }}>&#x21bb;</span>
      <span>{t('app.newVersionAvailable')}</span>
      {typeof reloadInSeconds === 'number' && reloadInSeconds > 0 && (
        <span style={{ opacity: 0.85, fontWeight: 500, fontSize: 13 }}>
          — Se actualiza automático en {reloadInSeconds}s
        </span>
      )}
      <button
        type="button"
        onClick={reloadNow}
        style={{
          background: '#fff', color: '#c2410c',
          padding: '6px 14px', borderRadius: 8,
          fontSize: 13, fontWeight: 700,
          border: 'none', cursor: 'pointer',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        }}
      >
        Actualizar ahora
      </button>
      <style>{`@keyframes pmSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

function App() {
  useEffect(() => {
    initWhatsAppSettings();
    // Capturar UTM al primer landing — sobrevive en localStorage hasta el
    // signup. Si el visitor llega de un mailing con ?utm_source=mailing,
    // queda atribuido aunque después navegue por el sitio antes de crear
    // la cuenta. Ver utils/utmAttribution.js.
    captureUtmFromUrl();
  }, []);

  return (
    <StaticDataProvider>
      <VersionCheck />
      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
        toastOptions={{ style: { fontSize: '14px' } }}
      />
      <Routes />
    </StaticDataProvider>
  );
}

export default App;
